class LanguageSelector extends HTMLElement {
  constructor() {
    super();

    this.init();
  }

  init() {
    const activeLanguage = this.querySelector('[data-language-selector-trigger]');
    const languageSelector = this.querySelector('[data-language-selector]');

    activeLanguage.addEventListener('click', () => {
      if (!document.body.classList.contains('language-selector--is-open')) {
        document.body.addEventListener('click', this.clickOutside);
        document.body.classList.add('language-selector--is-open');

        setTimeout(() => {
          document.body.classList.add('open-language-selector-transition');
        }, 100);
      } else {

        document.body.classList.add('close-language-selector-transition');

        setTimeout(() => {
          document.body.classList.remove('open-language-selector-transition', 'close-language-selector-transition', 'language-selector--is-open');
        }, 100);
        document.body.removeEventListener('click', this.clickOutside);
      }
    });
  }

  clickOutside() {
      const body = document.querySelector('body');
      const search = document.querySelector('#desktopSearchInModal');

      if (event.target === body || event.target === search) {
        document.body.classList.add('close-language-selector-transition');

        setTimeout(() => {
          document.body.classList.remove('open-language-selector-transition', 'close-language-selector-transition', 'language-selector--is-open');
        }, 100);
      }

  }
}

window.languageSelector = LanguageSelector;
customElements.define('language-selector', LanguageSelector);
